import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgColorfulLogoMicrosoft({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M7.65 1H1v6.65h6.65V1z" fill="#F25022" />
      <path d="M15 1H8.35v6.65H15V1z" fill="#7FBA00" />
      <path d="M7.65 8.35H1V15h6.65V8.35z" fill="#00A4EF" />
      <path d="M15 8.35H8.35V15H15V8.35z" fill="#FFB900" />
    </svg>
  );
}

SvgColorfulLogoMicrosoft.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgColorfulLogoMicrosoft.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgColorfulLogoMicrosoft svgRef={ref} {...props} />
));
export default ForwardRef;
